import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { PaisesEditarPage } from '../../pages/paises-editar/paises-editar'
import { Storage } from '@ionic/storage'
import { PaisesProvider } from '../../providers/paises/paises'
import { paises } from '../../models/paises'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { DenominacionesProvider } from '../../providers/denominaciones/denominaciones'
import { LoadingController } from 'ionic-angular';
import { NUBE_AWS } from '../../config/url.servicio';


@IonicPage()
@Component({
  selector: 'page-correo',
  templateUrl: 'correo.html',
  providers: [ AuthService ]
})
export class CorreoPage {
  correoElectronico: string = ""
  listaCorreoElectronico: any[] = []

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  loader
  companiasId:any = null
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: PaisesProvider ,
    public servicioCompania:CompaniasProvider,
    public denominaciones:DenominacionesProvider,
    public auth: AuthService,
    public loadingCtrl: LoadingController,
    public storage:Storage){
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          this.cargarServicio()
        }
        this.cargarServicio()
      })
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CorreoPage');
  }

  cargarServicio() {
    this.storage.get('companiasId').then((val)=>{
      let compania = val == undefined ? this.companiasId : val 
      this.denominaciones.buscarCorreo(compania)
      .subscribe((data) => {
        if(NUBE_AWS){
          this.listaCorreoElectronico = JSON.parse(data['_body']).data[0] ? JSON.parse(data['_body']).data[0] : []
        } else {
          this.listaCorreoElectronico = data
        }
      }, error => {
        console.log(error)
      })
    })
  }
  guardar() {
    this.guardarServicio()
  }
  guardarServicio() {
 
    this.loader = this.loadingCtrl.create({});
    this.loader.present();
    let datosCorreo: any = {
      correoElectronico: this.correoElectronico,
      queHago: "I",
      nombreTabla: "correos",
      name: "dataDynamicCrud"
    }

    this.storage.get('companiasId').then((val) => {
      datosCorreo['companiasId'] = val
    this.guardarCorreo(datosCorreo)

    });
}
guardarCorreo(datosCorreo){
    
  this.servicio.guardarCorreo(datosCorreo)
  .subscribe(
    res => this.procesarResultado(),
    err => this.mostrarMensajeDeError('No se pudo guardar el correo, intente luego')
  )
}
procesarResultado() {
  this.limpiar()
  this.loader.dismiss()
  this.cargarServicio()
}

limpiar() {
  this.correoElectronico = ""
  this.listaCorreoElectronico = []
}
mostrarMensajeDeError(mensaje) {
  let alert = this.alertControllers.create({
    title: 'Error',
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();

  this.loader.dismiss()
}

eliminarCorreo(item) {

  this.loader = this.loadingCtrl.create({});
  this.loader.present();

  this.servicio.eliminarCorreo(item)
  .subscribe(
    res => this.procesarResultado(),
    err => this.mostrarMensajeDeError('No se pudo eliminar el correo, intente luego')
  )
}

}


// WEBPACK FOOTER //
// ./src/pages/correo/correo.ts